import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SurerouteTestObjectComponent } from '../component/akamai/sureroute-test-object/sureroute-test-object.component';
import { HomePageComponent } from '../component/page/home-page/home-page.component';
import { SearchResultPageComponent } from '../component/page/search-result-page/search-result-page.component';
import { VersionComponent } from '../component/version/version.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomePageComponent },
  { path: 'version', component: VersionComponent },
  { path: 'search', component: SearchResultPageComponent },
  { path: 'akamai/sureroute-test-object.html', component: SurerouteTestObjectComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppHomeRoutingModule {}
